(function(api){
  "use strict";

  // Generate and set the UUID
  window.dfCONSTANTS = {
    localstorage: {
      uuid: 'dfGUID', // A general GUID for the site user
      utmParams: 'dfUTMParams', // Remembered UTM parameters for any user
      stickyHeaderDesktopClosed: 'dfStickyHeaderDesktopClosed', // Sticky header desktop closed
      cookieConsentClosed: 'dfCookieConsentClosed', // Cookie consent closed
    },
    apiHost: window.location.host === "drugfree.org" ?
      'https://api.drugfree.org' :
      'https://api-qa.drugfree.org', // The API host for the platform
    utmParams: [
      'utm_source',
      'utm_medium',
      'utm_content',
      'utm_term',
      'utm_campaign'
    ], // The UTMS to collect from each URL
  }

  // Get the query params on each page load
  const keyValues = api.getURLQueryParams(window.dfCONSTANTS.utmParams);

  // Save the values when UTMs are found.
  if(Object.keys(keyValues).length){
    window.localStorage.setItem(window.dfCONSTANTS.localstorage.utmParams, JSON.stringify(keyValues));
  }

})(window.dfApi);